<template>
  <div>
    <Header></Header>
    <!-- PAGE HEADER -->
    <div class="page-header author">
      <div class="container">
        <div class="row">
          <div class="col-md-offset-1 col-md-10 text-center">
            <div class="author">
              <img
                v-show="autor.image != ''"
                class="author-img center-block"
                :src="autor.image"
              />
              <h1 v-show="autor.name" class="text-uppercase">
                {{ autor.name }}
              </h1>
              <p v-show="autor.jobTitle" class="text-yellow">
                Profissão: {{ autor.jobTitle }}
                {{
                  autor.specialty ? ` | Especialidade: ${autor.specialty}` : ""
                }}
              </p>
              <p v-show="autor.workPlace" class="lead">
                {{ `Local atual de trabalho: ${autor.workPlace}` }}
              </p>
              <ul class="author-social">
                <li v-show="autor.facebook != ''">
                  <a :href="autor.facebook" rel="noreferrer" target="_blank">
                    <i class="fa fa-facebook"></i>
                  </a>
                </li>
                <li v-show="autor.twitter != ''">
                  <a :href="autor.twitter" rel="noreferrer" target="_blank">
                    <i class="fa fa-twitter"></i>
                  </a>
                </li>
                <li v-show="autor.linkedin != ''">
                  <a :href="autor.linkedin" rel="noreferrer" target="_blank">
                    <i class="fa fa-linkedin"></i>
                  </a>
                </li>
                <li v-show="autor.instagram != ''">
                  <a :href="autor.instagram" rel="noreferrer" target="_blank">
                    <i class="fa fa-instagram"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /PAGE HEADER -->

    <section class="mt-2">
      <div class="container">
        <div class="row">
          <div class="col-md-8">
            <div class="row">
              <div class="col-md-12">
                <div class="section-title mb-2">
                  <h1 class="title">PUBLICAÇÕES DE {{ autor.name }}</h1>
                </div>

                <div v-show="!firstLoading && posts.length < 1">
                  <p style="color:var(--secondary); text-align:left;">
                    {{ `${autor.name} ainda não possui nenhuma publicação.`
                    }}<br />
                  </p>
                </div>
              </div>

              <!-- post -->
              <div class="post post-row" v-for="post in posts" :key="post.id">
                <a class="post-img" :href="'/#/post/' + post.slug">
                  <img :src="post.image" :alt="post.title" />
                </a>
                <div class="post-body">
                  <div class="post-category">
                    <a
                      v-for="tag in post.tag"
                      :key="tag.id"
                      href="category.html"
                      >{{ tag.title }}</a
                    >
                  </div>
                  <h3 class="post-title">
                    <a :href="'/#/post/' + post.slug">{{ post.title }}</a>
                  </h3>
                  <ul class="post-meta">
                    <li>
                      <a :href="`#/autor/${post.user.id}`">{{
                        post.user.name
                      }}</a>
                    </li>
                    <li>{{ post.timestamp | moment("DD/MM/YYYY") }}</li>
                  </ul>
                  <p
                    class="post-card-description"
                    v-html="post.description"
                  ></p>
                </div>
              </div>
              <!-- /post -->

              <div v-show="firstLoading" class="loading-holder">
                <div class="loading-spinner"></div>
              </div>

              <div
                v-show="current < pages"
                @click="loadUserPosts"
                class="section-row loadmore text-center"
                style="cursor:pointer;"
              >
                <a v-show="!loadingMore" class="primary-button"
                  >Carregar mais</a
                >
                <div v-show="loadingMore" class="loading-spinner"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <Footer></Footer>
  </div>
</template>

<script>
import http from "@/http";
import Header from "../components/Header";
import Footer from "../components/Footer";

export default {
  name: "Autor",
  components: {
    Header,
    Footer
  },
  data() {
    return {
      autor: {
        id: null,
        name: "",
        image: "",
        description: "",
        jobTitle: "",
        facebook: "",
        instagram: "",
        linkedin: "",
        twitter: ""
      },
      posts: [],
      current: 0,
      pages: null,
      firstLoading: true,
      loadingMore: false
    };
  },
  created() {
    this.loadUser();
  },
  methods: {
    loadUser() {
      http
        .get(`user/${this.$route.params.id}`)
        .then(response => {
          this.autor = response.data;
          this.loadUserPosts();
        })
        .catch(err => {
          console.error(err);
          this.firstLoading = false;
          this.loadingMore = false;
        });
    },
    loadUserPosts() {
      if (this.current > 0) {
        this.loadingMore = true;
      }
      http
        .get(`post/search?user=${this.autor.id}&page=${this.current}&take=10`)
        .then(response => {
          this.posts = [...this.posts, ...response.data.list];
          localStorage.x = JSON.stringify(response.data);
          this.pages = response.data.pages;
          this.current++;
        })
        .catch(err => {
          console.log(err);
          this.firstLoading = false;
          this.loadingMore = false;
        })
        .finally(() => {
          this.firstLoading = false;
          this.loadingMore = false;
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/Autor.vue